// extracted by mini-css-extract-plugin
export var form = "_cq-0";